import React from 'react';
import { Image, LazyImage, Link, Markup } from '@landing/ui';
import { Container, Button } from 'components/UI';
import * as styles from './Intro.module.scss';

export default function Intro({ logos, title, subtitle, img, button }) {
  return (
    <Container background="white" padding="Without">
      <Container className={styles.innerContainer} theme="inner" background="darkPrimary">
        <Image className={styles.picture} classImage={styles.img} src={img} />
        <div className={styles.layout}>
          {logos?.map(({ src, link, alt }) => {
            const LogoWrapper = link ? Link : 'div';

            return (
              <LogoWrapper key={src} className={styles.logoWrapper} href={link}>
                <LazyImage src={src} className={styles.logo} alt={alt} />
              </LogoWrapper>
            );
          })}
          <h1 className={styles.title}>{title}</h1>
          <Markup tag="p" className={styles.subtitle}>
            {subtitle}
          </Markup>
          {button && (
            <Button className={styles.button} theme="primary" target="_self" {...button}>
              {button.text}
            </Button>
          )}
        </div>
      </Container>
    </Container>
  );
}
